import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { isInternalLink } from 'helpers/ContentHelper';
import { helperGoToRelativeUrl } from 'helpers/RouteHelper';
import Style from './MyRewardsCTA.module.scss';

const MyRewardsCTA = ({ ctaText = 'Enter the MASKVERSE', rewardUrl = '', onCtaBannerClick }) => {
  const handleCTAClick = e => {
    e.stopPropagation();
    if (isInternalLink(rewardUrl)) {
      helperGoToRelativeUrl(rewardUrl);
    }
    onCtaBannerClick(ctaText);
  };

  const ctaProps = {
    className: Style.rewardsCTA,
    onClick: handleCTAClick,
    to: isInternalLink(rewardUrl) ? null : rewardUrl,
    target: isInternalLink(rewardUrl) ? null : '_blank',
  };
  return <Link {...ctaProps}>{ctaText}</Link>;
};

export default MyRewardsCTA;

MyRewardsCTA.propTypes = {
  ctaText: PropTypes.string,
  rewardUrl: PropTypes.string.isRequired,
  onCtaBannerClick: PropTypes.func.isRequired,
};
